module.exports = __webpack_public_path__ + "images/emoji/musical_note.dabffdf40c493cb5768d.png";